// extracted by mini-css-extract-plugin
export default {"modal":"Rda-z","modalContent":"Sda-z","footer":"Tda-z","cancelBtn":"Uda-z","disabled":"Vda-z","formWrapper":"Wda-z","fade":"Xda-z","fade-in":"Yda-z","iframe":"Zda-z"};